import { useState, type FormEvent } from 'react';
import clsx from 'clsx';

interface UserIdentityModalProps {
  onSubmit: (name: string) => void;
}

export function UserIdentityModal({ onSubmit }: UserIdentityModalProps) {
  const [name, setName] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (trimmed) onSubmit(trimmed);
  };

  return (
    <div className="modal-overlay">
      <div className="bg-white rounded-2xl p-10 w-full max-w-[400px] shadow-[0_25px_50px_rgba(0,0,0,0.15)]">
        <div className="flex items-center gap-3 mb-2">
          <span className="material-symbols-outlined text-[28px] text-text-primary">
            person
          </span>
          <h2 className="text-xl font-bold">Welcome to POI Planner</h2>
        </div>
        <p className="text-sm text-text-secondary mb-6 leading-relaxed">
          Enter a display name so your changes can be attributed to you.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Your name..."
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
            className="input-base mb-4"
          />
          <button
            type="submit"
            disabled={!name.trim()}
            className={clsx(
              'w-full py-2.5 px-4 rounded-lg text-sm font-bold font-sans border-none transition-colors',
              name.trim()
                ? 'bg-text-primary text-white cursor-pointer'
                : 'bg-gray-300 text-white cursor-not-allowed'
            )}
          >
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}
